export const ModalChangePhoneNumberTranslationsEn = {
  changePhoneNumber: 'Change phone number',
  phoneNumber: 'Phone number',
  saveButton: 'Save',
};
